var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{attrs:{"role":"row"}},[_c('th',{attrs:{"tabindex":"0","rowspan":"1","colspan":"1"}},[_vm._v("Lp")]),_vm._l((_vm.columns_list),function(column,i){return _c('th',{key:i,class:{
        sorting:
          column.sortable &&
          (column.sort == null || column.sort == undefined),
        sorting_asc: column.sortable && column.sort == 'ASC',
        sorting_desc: column.sortable && column.sort == 'DESC'
      },attrs:{"tabindex":"0","rowspan":"1","colspan":"1","aria-sort":"ascending"},on:{"click":function($event){return _vm.$emit('change-sorting', column)}}},[_vm._v(" "+_vm._s(column.name)+" ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }